<template>
  <div class="summary-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="分解状态">
              <el-select v-model="searchForm.mark" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option label="未分解" :value="0" />
                <el-option label="已分解" :value="1" />
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"/>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row>
              <el-col v-loading="loading" :span="24">
                <el-table
                  :data="tableData"
                  stripe
                  style="width: 100%">
                  <el-table-column
                    label="订单号"
                    prop="orderNum"
                    fixed
                    width="120">
                  </el-table-column>
                  <el-table-column
                    label="生产单号"
                    align="center"
                    fixed
                    width="120">
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF" v-if="scope.row.produnum!==null&&scope.row.produnum!==''&&scope.row.produnum!==undefined">{{scope.row.produnum}}</span>
                      <span style="font-weight: 500;color:#999999" v-if="scope.row.produnum===null||scope.row.produnum===''||scope.row.produnum===undefined">N/A</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="经销商"
                    prop="delname"
                    align="center"
                    width="120"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span :style="scope.row.delname && scope.row.delname.indexOf('VIP') > -1 ? 'font-weight: bold; color: #389e0d; font-style: italic;' : ''">
                        {{ scope.row.delname }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="终端地址"
                    prop="address"
                    show-overflow-tooltip
                    min-width="200">
                  </el-table-column>
                  <el-table-column
                    label="处理时间"
                    prop="opertime"
                    align="center"
                    width="150">
                  </el-table-column>
                  <el-table-column
                    label="处理人"
                    prop="username"
                    align="center"
                    width="80">
                  </el-table-column>
                  <el-table-column
                    label="承担总额"
                    align="center"
                    width="120">
                    <template slot-scope="scope">
                      <span style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin"></i> {{scope.row.factorycom}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="责任车间"
                    prop="factory"
                    show-overflow-tooltip
                    align="center"
                    width="140">
                  </el-table-column>
                  <el-table-column
                    label="分解状态"
                    width="100"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.decmark===0" type="warning">未分解</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.decmark===1">已分解</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="120"
                    fixed="right"
                    align="center"
                    label="操作">
                    <template slot-scope="scope">
                      <el-button v-if="scope.row.decmark===0" size="mini" @click.stop="oper(scope.row,false)" icon="el-icon-guide">立即分解</el-button>
                      <el-dropdown v-if="scope.row.decmark===1" size="small" @click.stop="oper(scope.row,true)" split-button icon="el-icon-search">
                        <i class="el-icon-search"></i> 查看
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item @click.native="oper(scope.row,false)"><i class="el-icon-edit-outline"></i> 修改</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="售后金额分解"
      :visible.sync="editVisible"
      width="562px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="editForm" v-loading="fullscreenLoading" :model="editForm" label-position="right" label-width="90px" size="small">
        <el-form-item label="订单信息" prop="orderinfo">
          <el-card shadow="hover" style="font-size: 12px;">
            <div>
              <span style="color:#99a9bf">订单号：</span>
              <span style="color:#606266">{{editForm.ordernum}}</span>
              <span style="color:#99a9bf;margin-left: 20px">生产单号：</span>
              <span style="color:#606266">{{editForm.productnum}}</span>
            </div>
            <div>
              <span style="color:#99a9bf">经销商：</span>
              <span style="color:#606266">{{editForm.delname}}</span>
              <span style="color:#99a9bf;margin-left: 20px">责任车间：</span>
              <span style="color:#606266">{{editForm.factory}}</span>
            </div>
            <div>
              <span style="color:#99a9bf;">终端地址：</span>
              <span style="color:#606266">{{editForm.address}}</span>
            </div>
            <div>
              <span style="color:#99a9bf;">承担总额：</span>
              <span style="color:#409EFF;font-weight: bold"><i class="el-icon-coin"></i> {{ editForm.amount }}</span>
            </div>
          </el-card>
        </el-form-item>
        <el-form-item v-if="editForm.rsonInfo.length>0" style="margin-bottom: 0;">
          <el-row v-for="(item, index) in editForm.rsonInfo" :key="item.key" class="after-rson-list">
            <el-col :span="24">
              <el-form-item :prop="'rsonInfo.' + index +'.amount'" :rules="rsonInfoRules.amount">
                <el-input v-model="item.amount" :disabled="isView" prefix-icon="el-icon-coin" placeholder="承担金额" oninput ="value=value.replace(/[^0-9.]/g,'')">
                  <template slot="prepend"><span style="font-weight: bold;margin-right: 10px"><i class="el-icon-paperclip"></i> {{item.dept}}</span>{{item.rson}}</template>
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" v-if="!isView" :loading="editLoading" size="small" @click="subEdit('editForm')">立即提交</el-button>
        <el-button size="small" @click="editVisible = false">{{isView?'关闭':'取消'}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

import { getUser } from '@/utils/auth'
import { getAfterAmountBreakdownList, getAfterAmountBreakdownDetail, editAfterAmountBreakdown } from '@/api/erp'
import qs from 'qs'

export default {
  name: 'shjefj',
  data() {
    return {
      searchForm: {
        search: '',
        mark: null
      },
      tableData: [],
      total: 0,
      pageSize: 20,
      currentPage: 1,
      loading: false,
      editVisible: false,
      fullscreenLoading: false,
      editLoading: false,
      isView: false,
      editForm: {
        asid: null,
        ordernum: '',
        productnum: '',
        delname: '',
        factory: '',
        address: '',
        amount: 0.0,
        rsonInfo: []
      },
      rsonInfoRules: {
        amount: [{ required: true, message: '请输入承担金额', trigger: 'blur' }]
      }
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getData()
  },
  methods: {
    Search() {
      if (this.searchForm.search !== null && this.searchForm.search.trim() !== '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.searchForm.search = ''
        this.getData()
      }
    },
    getData() {
      const data = {
        keyword: this.searchForm.search,
        mark: this.searchForm.mark,
        userid: this.user.dUserid,
        groupid: this.user.dGroupid,
        role: this.user.role,
        page: this.currentPage,
        limit: this.pageSize
      }
      this.loading = true
      getAfterAmountBreakdownList(data).then(response => {
        this.tableData = response.data
        this.total = response.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.currentPage = 1
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    oper(row, n) {
      this.isView = n
      this.editVisible = true
      this.editForm.ordernum = row.orderNum
      this.editForm.productnum = row.produnum
      this.editForm.delname = row.delname
      this.editForm.factory = row.factory
      this.editForm.address = row.address
      this.editForm.amount = row.factorycom
      this.fullscreenLoading = true
      this.editForm.rsonInfo = []
      getAfterAmountBreakdownDetail({ asid: row.asid }).then(response => {
        this.editForm.asid = response.data.as.asid
        var _rsonInfo = []
        for (const r of response.data.rson) {
          _rsonInfo.push({ id: r.id, dept: r.deptname, rson: r.rsonname, amount: r.amount })
        }
        this.editForm.rsonInfo = _rsonInfo
        this.fullscreenLoading = false
      }).catch(() => {
        this.fullscreenLoading = false
      })
    },
    subEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editLoading) {
            let reasonArr = []
            // var newamount = 0.0
            for (const r of this.editForm.rsonInfo) {
              reasonArr.push({ id: r.id, amount: r.amount })
              // if (r.amount !== undefined && r.amount !== null) {
              //   newamount = newamount + parseFloat(r.amount)
              // }
            }
            // if (newamount > this.editForm.amount) {
            //   this.$message.error('分解总额不能大于承担总额')
            //   return false
            // }
            this.editLoading = true
            const data = {
              rson: qs.parse(reasonArr),
              asid: this.editForm.asid
            }
            editAfterAmountBreakdown(data).then(response => {
              this.$message({
                message: '售后金额分解提交成功',
                type: 'success'
              })
              this.editLoading = false
              this.editVisible = false
              this.getData()
            }).catch(() => {
              this.editLoading = false
            })
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.summary-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
